import { Spin } from 'antd'
import React from 'react'

const Loading = ({height="h-full"}) => {
  return (
    <div className={`${height} flex items-center justify-center w-full`}>
      <Spin size='large'></Spin>
    </div>
  )
}

export default Loading
